var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom_player",class:_vm.detached || _vm.always_detached ? 'detached detached-'+_vm.state.profile.bottom_player_size : ''},[(!_vm.slave)?_c('player-core'):_vm._e(),_c('player-progress'),_c('player-controls'),_c('player-title'),_c('player-time')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }